module.exports = __webpack_public_path__ + "img/f4-2.7129f19f.png";